import { OnInit, ChangeDetectorRef } from '@angular/core';
import { UiService } from '../ui/ui.service';
import { MenuService } from '../menu/menu.service';
import { Router, NavigationEnd } from '@angular/router';
import { LinksService } from '../links/links.service';
import { filter } from 'rxjs/operators';
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(ui, changeDetectorRef, menu, router, linksService) {
        var _this = this;
        this.ui = ui;
        this.changeDetectorRef = changeDetectorRef;
        this.menu = menu;
        this.router = router;
        this.isHomePage = false;
        this.links = [];
        this.treeWhiteSvgStr = require('../logo/tree-white.svg');
        this.treeSvgStr = require('../logo/tree.svg');
        ui.accentuated$.subscribe(function (b) { return _this.accentuated = b; });
        ui.accentuated$.subscribe(function () { return changeDetectorRef.detectChanges(); });
        ui.whitened$.subscribe(function (b) { return _this.whitened = b; });
        ui.whitened$.subscribe(function () { return changeDetectorRef.detectChanges(); });
        ui.title$.subscribe(function (t) {
            if (!!t)
                _this.lastTitle = t;
            _this.titleVisible = !!t;
        });
        this.router.events
            .pipe(filter(function (e) { return e instanceof NavigationEnd; }))
            .subscribe(function (e) {
            _this.isHomePage = e.url.split('?')[0] === '/';
        });
        this.links = linksService.links.filter(function (l) { return !l.only || l.only.indexOf('header') !== -1; });
    }
    HeaderComponent.prototype.ngOnInit = function () {
    };
    HeaderComponent.prototype.clickMenuButton = function () {
        this.menu.toggle();
    };
    return HeaderComponent;
}());
export { HeaderComponent };
//# sourceMappingURL=header.component.js.map